// extracted by mini-css-extract-plugin
export default {"valueColumn":"style_valueColumn__6Qp9j"};